import { createSelector } from 'src/universal/redux/utils';
import { getPageGlobalData } from 'src/universal/redux/page';
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';
import { hasPznDataArrived, getPznOfferList } from 'src/universal/redux/pznData';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';

///utils
export const isDualOffer = (pznOffer = {}) => {
  const offerContent = Array.isArray(pznOffer?.content) ? pznOffer?.content : [];
  const dualOfferHeader = offerContent[0]?.header;
  const dualOfferDescription = offerContent[0]?.description;
  return dualOfferHeader && dualOfferDescription;
};

export const isSpecialOffer = (pznOffer = {}) => {
  const offerText = pznOffer?.offerButton || '';
  return (
    String(offerText)
      .toLowerCase()
      .indexOf('special') > -1
  );
};

export const isLTO = (pznOffer = {}) => {
  const offerText = pznOffer?.offerButton || '';
  return (
    String(offerText)
      .toLowerCase()
      .indexOf('limited time offer') > -1
  );
};

export const doOfferStylingPgEvents = offerStylingPgLoadDtms => {
  if (Array.isArray(offerStylingPgLoadDtms)) {
    offerStylingPgLoadDtms.forEach(dtm => {
      sendDTMCustomEvent(dtm);
    });
  }
};

export const getRibbonDtmKeyByPznOffer = (pznOffer = {}) => {
  if (isSpecialOffer(pznOffer)) {
    return 'visibleSpecialOfferRibbon';
  }

  if (isLTO(pznOffer)) {
    return 'visibleLtoRibbon';
  }

  return 'visibleNoOfferRibbon';
};

/////

///selectors
export const getOfferStylingPageLoadDtmList = createSelector(
  [
    hasPznDataArrived,
    getPznOfferList,
    getPageGlobalData,
    (_, filterList) => filterList
  ],
  (hasPznArrived, offerList = [], { offerStyling }, filterList) => {
    /*
      US4294061: 
      (1) this func will return an array of dtm objs.
      (2) filterList: if passed in, contains a list of short names.
      */
    const dtmEvtList = offerStyling?.dtmEvents || [];
    const result = [];
    const cardsHavingLto = [];
    const cardsHavingSpecialOffers = [];
    const cardsHavingDualOffers = [];
    let hasOffer = false;

    if (!hasPznArrived || offerList.length <= 0) {
      return [];
    }

    let targetOfferList = offerList;

    if (Array.isArray(filterList) && filterList.length > 0) {
      targetOfferList = offerList.filter(offer => {
        return filterList.indexOf(offer.shortName) > -1;
      });
    }

    targetOfferList.forEach(offer => {
      if (isLTO(offer)) {
        cardsHavingLto.push(offer.shortName);
      }
      if (isSpecialOffer(offer)) {
        cardsHavingSpecialOffers.push(offer.shortName);
      }
      if (isDualOffer(offer)) {
        cardsHavingDualOffers.push(offer.shortName);
      }
    });

    const makeDtm = (shortNameList, dtmKey) => {
      hasOffer = true;
      const targetDtm = dtmEvtList.find(d => d.key === dtmKey) || {};
      return {
        ...targetDtm,
        eventAsset: replaceStringWithVars({
          varsObject: { product: shortNameList.join('_') },
          string: targetDtm?.eventAsset || ''
        })
      };
    };

    if (cardsHavingLto.length > 0) {
      result.push(makeDtm(cardsHavingLto, 'pageLoadLTO'));
    }
    if (cardsHavingSpecialOffers.length > 0) {
      result.push(makeDtm(cardsHavingSpecialOffers, 'pageLoadSpecialOffer'));
    }
    if (cardsHavingDualOffers.length > 0) {
      result.push(makeDtm(cardsHavingDualOffers, 'pageLoadDualOffer'));
    }
    if (!hasOffer) {
      const noOfferDtm = dtmEvtList.find(d => d.key === 'pageLoadNoOffer') || {};
      result.push({ ...noOfferDtm });
    }

    return result;
  }
);

export const getOfferStylingDtm = createSelector(
  [
    hasPznDataArrived,
    getPznOfferList,
    getPageGlobalData,
    (_, shortName) => shortName
  ],
  (hasPznArrived, offerList = [], { offerStyling }, shortName) => {
    const dtmEvtList = offerStyling?.dtmEvents || [];

    if (!hasPznArrived || offerList.length <= 0) {
      return {};
    }

    const targetOffer = offerList.find(o => o.shortName === shortName);
    const ribbonDtmKey = getRibbonDtmKeyByPznOffer(targetOffer);
    const targetDtm = dtmEvtList.find(d => d.key === ribbonDtmKey) || {};

    return {
      ...targetDtm,
      eventAsset: replaceStringWithVars({
        varsObject: { product: shortName },
        string: targetDtm?.eventAsset || ''
      })
    };
  }
);
